import script from "./CustomTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTagList.vue?vue&type=script&setup=true&lang=js"

import "./CustomTagList.vue?vue&type=style&index=0&id=432230ab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432230ab"]])

export default __exports__